import { useEffect } from "react";

/**
 * useMobileFormShell — toggles the `fo-mobile-form` body class so the
 * mobile tap-target / safe-area CSS layer in index.css activates.
 * Idempotent. Add this hook to every `/new` route's top-level component.
 */
export function useMobileFormShell() {
  useEffect(() => {
    document.body.classList.add("fo-mobile-form");
    return () => {
      document.body.classList.remove("fo-mobile-form");
    };
  }, []);
}
